import { Box } from '@mui/material';
import { infoContainerSx, infoSectionSx } from '../../styles/Global.style';

export const ReferralPolicy = () => (
  <Box component="div" sx={infoSectionSx}>
    <Box component="div" sx={infoContainerSx}>
      <p>
        <strong>BALJAFFRAY PRIMARY SCHOOL PARENT-TEACHER ASSOCIATION</strong>
      </p>
      <p>
        <strong>Referral Policy</strong>
      </p>
      <p>
        This policy is relevant to all those involved in making
        recruitment/disciplinary decisions in our organisation.
      </p>
      <p>
        When a volunteer or member is permanently removed from a regulated role,
        there are certain circumstances where our organisation must notify
        Disclosure Scotland that this has happened. This is called &ldquo;Making
        a Referral&rdquo;. If we would have permanently removed the individual,
        the actions detailed in this policy will continue to apply (even if a
        member or volunteer leaves their regulated role prior to any action
        being taken, irrespective of the reason that they leave).
      </p>
      <p>
        2 conditions must be met before we let Disclosure Scotland know that
        something has happened.
      </p>
      <p>
        <strong>Condition 1</strong> &ndash; A person has been permanently
        removed/removed themselves from a regulated role
      </p>
      <p>
        <strong>Condition 2</strong> &ndash; At least 1 of the following 5
        grounds apply:
      </p>
      <ul>
        <li>Caused harm to a child or protected adult</li>
        <li>Placed someone at risk of harm</li>
        <li>Engaged in inappropriate conduct involving pornography</li>
        <li>Engaged in inappropriate sexual conduct</li>
        <li>Given inappropriate medical treatment</li>
      </ul>
      <p>
        When both of these conditions have been met, it is a legal requirement
        that we must let Disclosure Scotland know by making a referral within 3
        months of the permanent removal of the individual.&nbsp;
      </p>
      <p>
        Where there is an historical allegation of harm or inappropriate
        behaviour about someone who is no longer in a regulated role with us but
        which we believe would, in all probability, have led to the 2 conditions
        being met, we will consider whether we want to make a referral but the
        legal responsibility applies only after 28 February 2011 when PVG was
        first introduced.
      </p>
      <p>
        Where it is necessary to make a referral, this process will be carried
        out by <strong>Baljaffray Primary School PTA Chair</strong>.
      </p>
      <p>
        In their absence, the referral process will be carried out by&nbsp;
        <strong>Baljaffray Primary School PTA Secretary</strong>.
      </p>
      <p>
        Those who are in a position which may involve carrying out disciplinary
        action which may result in the removal from a regulated role or
        dismissal of someone in a regulated role, must ensure they notify&nbsp;
        <strong>Baljaffray Primary School PTA Chair</strong>&nbsp;or, in their
        absence, <strong>Baljaffray Primary School PTA Secretary</strong>,
        &nbsp;of the legal requirement to make a referral where the conditions
        above have been met.
      </p>
      <p>
        Failure to make a referral where required, may result in our
        organisation being prosecuted. It is therefore essential that those
        involved in carrying out disciplinary action notify{' '}
        <strong>Baljaffray Primary School PTA Chair</strong>&nbsp;or{' '}
        <strong>Baljaffray Primary School PTA Secretary</strong>&nbsp;when both
        conditions for making a referral have been met.
      </p>
    </Box>
  </Box>
);
